<script lang="ts">
  export let penalties: string[] = []
</script>

<ol class="px-6 py-4 space-y-1 prose-sm prose list-disc">
  {#each penalties as p}
    <li>{p}</li>
  {/each}
</ol>
